var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M81.4339 71.2518C67.2767 96.0195 39.5013 106.386 19.4565 94.6967C-0.593311 83.0044 -5.59149 53.5166 8.56612 28.7482C22.7233 3.98052 50.4987 -6.38602 70.5435 5.30335C90.5933 16.9956 95.5915 46.4834 81.4339 71.2518Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M58.0731 50.4671L59.5 50L58.0731 49.5329C53.834 48.145 50.3671 45.0373 48.5136 40.9636L47.6201 39L46.7305 39.4085L47.624 41.3721C49.2403 44.9245 52.0126 47.7849 55.4458 49.5093H30.5V50.4907H55.4459C52.0127 52.2151 49.2403 55.0754 47.624 58.6279L46.7305 60.5915L47.6201 61L48.5136 59.0364C50.3671 54.9627 53.834 51.855 58.0731 50.4671Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInCircle);
export default __webpack_public_path__ + "static/media/arrow-in-circle.e0c991a2740c3fd59951c230fc651eef.svg";
export { ForwardRef as ReactComponent };